import { render, staticRenderFns } from "./plate.vue?vue&type=template&id=630be7d0&scoped=true&"
import script from "./plate.vue?vue&type=script&lang=js&"
export * from "./plate.vue?vue&type=script&lang=js&"
import style0 from "./plate.vue?vue&type=style&index=0&id=630be7d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630be7d0",
  null
  
)

export default component.exports